import { render, staticRenderFns } from "./AnnouncementForm.vue?vue&type=template&id=87fc349a&scoped=true"
import script from "./AnnouncementForm.vue?vue&type=script&lang=js"
export * from "./AnnouncementForm.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementForm.vue?vue&type=style&index=0&id=87fc349a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fc349a",
  null
  
)

export default component.exports